export const toCamelCase = (str) => {
  return str
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase());
};

export const toTitleCase = (str) => {
  return str
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};
